import { render, staticRenderFns } from "./headSider.vue?vue&type=template&id=627d1724"
import script from "./headSider.vue?vue&type=script&lang=js"
export * from "./headSider.vue?vue&type=script&lang=js"
import style0 from "./headSider.vue?vue&type=style&index=0&id=627d1724&prod&lang=scss"
import style1 from "./headSider.vue?vue&type=style&index=1&id=627d1724&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports